/* eslint-disable no-restricted-imports */
import React, { useEffect, useMemo } from "react";
import { Modal } from "react-bootstrap";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { ModalProgressBar } from "../../../../../../_metronic/_partials/controls";
import * as actions from "../../../_redux/schThesises/schThesisesActions";
import { useSchThesisesUIContext } from "../SchThesisesUIContext";


//schThesisDeleteDialog commit test1

export function SchThesisDeleteDialog({ id, show, onHide }) {
  // SchThesises UI Context
  const schThesisesUIContext = useSchThesisesUIContext();
  const schThesisesUIProps = useMemo(() => {
    return {
      setIds: schThesisesUIContext.setIds,
      queryParams: schThesisesUIContext.queryParams,
    };
  }, [schThesisesUIContext]);

  // SchThesises Redux state
  const dispatch = useDispatch();
  const { isLoading } = useSelector(
    (state) => ({ isLoading: state.schThesises.actionsLoading }),
    shallowEqual
  );

  // if !id we should close modal
  useEffect(() =>  {
    if (!id) {
      onHide();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  // looking for loading/dispatch/
  useEffect(() => {}, [isLoading, dispatch]);

  const deleteSchThesis = () => {
    // server request for deleting schThesis by id
    dispatch(actions.deleteSchThesis(id)).then(() => {
      // refresh list after deletion
      dispatch(actions.fetchSchThesises(schThesisesUIProps.queryParams));
      // clear selections list
      schThesisesUIProps.setIds([]);
      // closing delete modal
      onHide();
    });
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      aria-labelledby="example-modal-sizes-title-lg"
    >
      {isLoading && <ModalProgressBar variant="query" />}
      <Modal.Header closeButton>
        <Modal.Title id="example-modal-sizes-title-lg">
          SchThesis Delete
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {!isLoading && (
          <span>Are you sure to permanently delete this schThesis?</span>
        )}
        {isLoading && <span>SchThesis is deleting...</span>}
      </Modal.Body>
      <Modal.Footer>
        <div>
          <button
            type="button"
            onClick={onHide}
            className="btn btn-light btn-elevate"
          >
            Cancel
          </button>
          <> </>
          <button
            type="button"
            onClick={deleteSchThesis}
            className="btn btn-delete btn-elevate"
          >
            Delete
          </button>
        </div>
      </Modal.Footer>
    </Modal>
  );
}
